import pythonApiClient from './pythonBaseApi';

// Usar cliente base compartido de Python API
// Las rutas son relativas a /api, así que solo especificamos el path del endpoint
const basePath = '/mantenimientos/zonas';

export const zonaApi = {
  // Obtener todas las zonas
  getZonas: async (proyectoId = null, soloActivas = null) => {
    const params = {};
    if (proyectoId) params.proyecto_id = proyectoId;
    if (soloActivas !== null && soloActivas !== undefined) {
      params.solo_activas = soloActivas;
    }
    return pythonApiClient.get(`${basePath}/`, { params });
  },

  // Obtener zonas con estadísticas
  getZonasWithStats: async (proyectoId = null) => {
    const params = proyectoId ? { proyecto_id: proyectoId } : {};
    return pythonApiClient.get(`${basePath}/stats`, { params });
  },

  // Obtener zona por ID
  getZonaById: async (zonaId) => {
    return pythonApiClient.get(`${basePath}/${zonaId}`);
  },

  // Obtener estadísticas de una zona
  getZonaStatistics: async (zonaId) => {
    return pythonApiClient.get(`${basePath}/${zonaId}/statistics`);
  },

  // Crear zona
  createZona: async (zonaData) => {
    return pythonApiClient.post(`${basePath}/`, zonaData);
  },

  // Actualizar zona
  updateZona: async (zonaId, zonaData) => {
    return pythonApiClient.put(`${basePath}/${zonaId}`, zonaData);
  },

  // Activar / inactivar zona
  cambiarEstadoZona: async (zonaId, activo) => {
    return pythonApiClient.patch(`${basePath}/${zonaId}/estado`, { activo });
  },

  // Validar si la zona puede inactivarse
  validarInactivacionZona: async (zonaId) => {
    return pythonApiClient.get(`${basePath}/${zonaId}/validar-inactivacion`);
  },

  // Eliminar zona
  deleteZona: async (zonaId) => {
    return pythonApiClient.delete(`${basePath}/${zonaId}`);
  },

  // Buscar zonas
  searchZonas: async (searchTerm, proyectoId = null) => {
    const params = { q: searchTerm };
    if (proyectoId) {
      params.proyecto_id = proyectoId;
    }
    return pythonApiClient.get(`${basePath}/search/`, { params });
  },

  // Obtener zonas por proyecto con información agregada
  getZonasByProyecto: async (proyectoId) => {
    return pythonApiClient.get(`${basePath}/proyecto/${proyectoId}`);
  },
};

export default zonaApi;